import React from "react";
import NewEpkBtn from "./NewEpkBtn";
import { useTranslation } from "react-i18next";

export default function EmptyEpk() {
  const { t } = useTranslation();
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-6 tw-py-24 tw-rounded-xl tw-border tw-border-dashed tw-border-white/10">
      <div className="tw-text-center">
        <p className="tw-text-lg tw-font-light tw-text-white/50 tw-m-0">{t("You don't have any EPK created.")}</p>
        <p className="tw-text-sm tw-text-white/30 tw-m-0">{t("Start promoting your film right away!")}</p>
      </div>
      <NewEpkBtn />
    </div>
  );
}
